import { extent } from "d3-array";
import { scaleBand, scaleLinear, scaleOrdinal } from "@visx/scale";
import { Group } from "@visx/group";
import { schemeTableau10 } from "d3-scale-chromatic";

const MiniBarPlot = ({ plotHeight, plotWidth, yearData, marginForEachSide, surveyAnswers, opacity=0.7 }) => {

    const uniqueAnswers = surveyAnswers ? surveyAnswers : [...new Set(yearData.map(d => Object.keys(d.responses)).flat())];

    const xScale = scaleBand({
        domain: uniqueAnswers,
        range: [0, plotWidth - (marginForEachSide * 2)],
        padding: 0
    });
    // Plot setup
    const yExtent = extent(yearData.map(d => Object.values(d.responses)).flat());
    const yRangeMin = 0;
    const domain = [yRangeMin, yExtent[1] + 0.05]
    const yScale = scaleLinear({
        domain,
        range: [plotHeight - (marginForEachSide * 2), 0]
    });
    const barWidth = xScale.bandwidth();
    const colorScale = scaleOrdinal({ domain: uniqueAnswers, range: schemeTableau10 })

    return (
        <svg 
        style={{ display: 'block',pointerEvents: 'none'}}
        width={plotWidth}
        height={plotHeight}
    >
        <Group>
            <Group
                top={marginForEachSide}
                left={marginForEachSide}
            >
                {uniqueAnswers.map(answer =>
                (
                    <rect
                        key={`mini-${answer}`}
                        x={xScale(answer)}
                        width={barWidth}
                        height={
                            (plotHeight - yScale(yearData[0]['responses'][answer])) - (marginForEachSide)
                        }
                        y={yScale(yearData[0]['responses'][answer])}
                        fill={colorScale(answer)}
                        opacity={opacity}
                    />
                )
                )}
            </Group>
        </Group>
        </svg>
    )
}

export default MiniBarPlot;